import { DicomJsonObjeto } from '../../../../atendimento/core/_models'

const PIXEL_SPACING = '00280030'
const IMAGER_PIXEL_SPACING = '00181164'

const temValor = (instancia: DicomJsonObjeto, tag: string): boolean => {
  const valor = instancia[tag]?.Value
  return Array.isArray(valor) && valor.length > 0
}

/** Calibrado só se todas as instâncias têm PixelSpacing ou ImagerPixelSpacing; na dúvida, não. */
export const estudoTemCalibracao = (metadata: unknown): boolean => {
  if (!Array.isArray(metadata) || metadata.length === 0) return false
  return metadata.every(
    (instancia: unknown) =>
      typeof instancia === 'object' &&
      instancia !== null &&
      (temValor(instancia as DicomJsonObjeto, PIXEL_SPACING) ||
        temValor(instancia as DicomJsonObjeto, IMAGER_PIXEL_SPACING))
  )
}
